import { capitalize, words } from "es-toolkit/string";

export function titleize(str: string): string {
  return words(str.toLowerCase().replace(/_/g, " ")).map(capitalize).join(" ");
}
